<template>
  <div class="sidebar">
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
      class="float-position-alert"
    >
      <p>{{ message }}</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      >
      </b-progress>
    </b-alert>
    <div class="block-screen" v-if="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <SidebarHeader />
    <SidebarForm />
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <template v-for="item in navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper"
            />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class" />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown
                :name="item.name"
                :url="item.url"
                :icon="item.icon"
              >
                <template v-for="childL1 in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      :name="childL1.name"
                      :url="childL1.url"
                      :icon="childL1.icon"
                    >
                      <li
                        class="nav-item"
                        v-for="childL2 in childL1.children"
                      >
                        <SidebarNavLink
                          :name="childL2.name"
                          :url="childL2.url"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="item.variant"
                        />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :url="childL1.url"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="item.variant"
                      />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :url="item.url"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant"
                />
              </SidebarNavItem>
            </template>
          </template>
        </template>
        <li class="nav-item" @click="excel">
          <div>
            <a class="nav-link"> <i class="fa fa-download"></i> Planilha </a>
          </div>
        </li>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter />
    <SidebarMinimizer />
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
export default {
  name: 'sidebar',
  data () {
    return {
      loading: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      message: ''
    }
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    excel () {
      this.loading = true
      this.$http
        .get(`participants/excel`)
        .then((response) => {
          this.message = response.data.message
          this.showAlert()
          this.loading = false
        })
        .catch((response, err) => {
          console.error(err)
          this.loading = false
        })
    },
    excelParticipantsGuests () {
      this.loading = true
      this.$http
        .get(`participants/excel-participants-guests`)
        .then((response) => {
          this.message = response.data.message
          this.showAlert()
          this.loading = false
        })
        .catch((response, err) => {
          this.loading = false
        })
    },
    excelParticipants () {
      this.loading = true
      this.$http
        .get(`participants/excel-participants`)
        .then((response) => {
          this.message = response.data.message
          this.showAlert()
          this.loading = false
        })
        .catch((response, err) => {
          this.loading = false
        })
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}

.float-position-alert {
  position: absolute;
  left: 100%;
  width: calc(100vw - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue